
//types
import { GET_AUTH } from './types'

//firebase
import { auth } from '../Config/Firebase'

export function authenticate_firebase_user() {
    return dispatch => {

        auth.onAuthStateChanged(user => {
            dispatch({
                type: GET_AUTH, 
                payload: user
              });
          });
      };   
}


export function logout() {
    return dispatch => auth.signOut();
}




// WEBPACK FOOTER //
// ./src/Actions/authAction.js